export default __webpack_public_path__ + "static/media/giving.fa1b256d.jpeg";